const getDateString = (time) =>
    time instanceof Date
        ? `${time.getUTCFullYear()}-${String(time.getUTCMonth() + 1).padStart(2, "0")}-${String(
              time.getUTCDate()
          ).padStart(2, "0")}`
        : "";

export { getDateString };
